export const GET_POSITIONS_SCREEN = 'positionsScreen/GET_POSITIONS_SCREEN'
export const START_LOADING_POSITIONS_SCREEN = 'positionsScreen/START_LOADING_POSITIONS_SCREEN'
export const STOP_LOADING_POSITIONS_SCREEN = 'positionsScreen/STOP_LOADING_POSITIONS_SCREEN'
